export const StatusBadge = ({ status, showText = true, size = 'sm' }) => {
  const config = {
    up: { dot: 'dot-up', text: 'status-up', label: 'UP', bg: 'bg-status-up/10 border-status-up/20 text-status-up' },
    degraded: { dot: 'dot-degraded', text: 'status-degraded', label: 'DEGRADED', bg: 'bg-status-degraded/10 border-status-degraded/20 text-status-degraded' },
    down: { dot: 'dot-down', text: 'status-down', label: 'DOWN', bg: 'bg-status-down/10 border-status-down/20 text-status-down' },
    unknown: { dot: 'dot-unknown', text: 'status-unknown', label: 'UNKNOWN', bg: 'bg-muted border-border text-muted-foreground' },
  };

  const cfg = config[status] || config.unknown;

  if (!showText) {
    return (
      <span
        className={`inline-block rounded-full ${size === 'lg' ? 'w-3 h-3' : 'w-2 h-2'} ${cfg.dot} pulse-dot`}
        title={cfg.label}
      />
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-xs font-semibold font-mono uppercase tracking-wide ${cfg.bg}`}
      data-testid={`status-badge-${status}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
};

export const StatusDot = ({ status }) => {
  const dots = {
    up: 'dot-up',
    degraded: 'dot-degraded',
    down: 'dot-down',
    unknown: 'dot-unknown',
  };
  return <span className={`inline-block w-2 h-2 rounded-full ${dots[status] || dots.unknown} pulse-dot`} />;
};
